// TODO: Move UserStore to immutable.js

import { EventEmitter } from 'events';
import ga from 'react-ga';
import { merge, mergeWith, isPlainObject, cloneDeep } from 'lodash';
import Dispatcher from 'core/Dispatcher';
import Actions from 'constants/Actions';
import CategoryStore from 'stores/CategoryStore';
import { validate } from 'api';
import { submit } from 'api';

const CHANGE_EVENT = 'change';

var _user = {
    id: {
        name: 'id',
        value: undefined,
    },
    name: {
        name: 'name',
        value: '',
    },
    email: {
        name: 'email',
        value: '',
    },
    password: {
        name: 'password',
        value: '',
    },
    phone_mobile: {
        name: 'phone_mobile',
        value: undefined,
    },
    phone_additional: {
        name: 'phone_additional',
        value: undefined,
    },
    has_account: {
        name: 'has_account',
        value: false,
    },
    legal_name: {
        name: 'legal_name',
        value: '',
    },
    inn: {
        name: 'inn',
        value: '',
    },
    kpp: {
        name: 'kpp',
        value: '',
    },
    address_legal: {
        name: 'address_legal',
        value: '',
    },
    address_real: {
        name: 'address_real',
        value: '',
    },
    contact_person: {
        name: 'contact_person',
        value: '',
    },
    with_vat: {
        name: 'with_vat',
        value: 1,
    },
    isPhoneOrMail: {
        name: 'isPhoneOrMail',
        value: false,
    },
};

var _showTips = {
    tip1: {
        name: 'tip1',
        value: true,
    },
    tip2: {
        name: 'tip2',
        value: true,
    },
}

var _onetimeToken = undefined;
var _autologinHash = undefined;
var _hasVVauthorization = false;
var _authWasChecked = false;
var userBalance = 0;

function updateUser({ name, value }) {
    merge(_user[name], {
        name,
        value,
        error: '',
    });
}

function updateShowTips({ name, value }) {
    merge(_showTips[name], {
        name,
        value,
        error: '',
    });

    _showTips = cloneDeep(_showTips);
}

function setValidToken(token) {
    _onetimeToken = token;
}

function setAutologinHash(hash) {
    _autologinHash = hash;
}

function normalizePhone(phone) {
    const nothing = '';

    if (phone) {
        if (phone.length <=5) {
            return nothing;
        } else {
            return phone.replace(/\s|-/g, '');
        }
    } else {
        return nothing;
    }
};

function sendToGa() {

    var selectedCategory = CategoryStore.getSelected();

    var prefix = '';
    if (_user.has_account.value) {
        prefix = 'reg';
    }

    Object.values(_user).forEach((param) => {

        if (_user.has_account.value &&
            param.name !== _user.email.name &&
            param.name !== _user.password.name) {
            return false;
        }

        if (param.value === undefined || param.value === false || param.value === '') {
            return false;
        }

        if ((param.name === _user.phone_mobile.name || param.name === _user.phone_additional.name) &&
            param.value.length <= 5) {
            return false;
        }

        var ga_action_name = param.name;
        if (prefix) {
            ga_action_name = `${prefix}_${ga_action_name}`;
        }

        ga.event({
            category: 'fields',
            action: `fill_${ga_action_name}_booking_step_5`,
            label: selectedCategory.name,
            value: 1,
        });
    });
}

function setVVauthorizationStatus(isAuthorized) {
    _hasVVauthorization = isAuthorized;
    _authWasChecked = true;
}

function setUserBalance(amount) {
    userBalance = amount;
}
class UserStore extends EventEmitter {

    getUser() {
        return _user;
    }

    getShowTips() {
        return _showTips;
    }

    hasToken() {
        return _onetimeToken !== undefined;
    }

    hasAutologinHash() {
        return _autologinHash !== undefined;
    }

    hasVVauthorization() {
        return _hasVVauthorization !== false;
    }

    wasAuthChecked() {
        return _authWasChecked;
    }

    hasBalance() {
        return userBalance;
    }
    
    hasAccount() {
        return _user.has_account.value === true
    }

    mergeUserErrors(userErrors) {
        mergeWith(_user, userErrors, (source, error) => {
            if (!isPlainObject(error) && typeof error !== 'string') {
                return;
            }

            if (error) {
                return merge({}, source, { error });
            }
        });
    }

    normalizeState(result) {
        if (_onetimeToken) {
            result.user = {
                onetime_token: _onetimeToken,
            }
        } else if (_autologinHash) {
            result.user = {
                autologin_hash: _autologinHash,
            }
        } else {
            result.user = {}
        }
    
        result.user = Object.assign(result.user, Object.values(_user).reduce((result, user) => {
            let value = user.value
            let name = user.name
        
            if (typeof value === 'boolean') {
                value = value ? 1 : 0
            }
            
            if (name === 'phone_mobile' || name === 'phone_additional') {
                result[name] = normalizePhone(value)
            } else {
                result[name] = value
            }
            
            if (name === 'with_vat' && Array.isArray(value)) {
                result[name] = value[0]
            }
        
            return result
        }, {}))
    }

    denormalizeState(normalizedState) {
        if (normalizedState.user && normalizedState.user.autologin_hash) {
            setAutologinHash(normalizedState.user.autologin_hash);
        }
        
        if (normalizedState.user && normalizedState.user.email) {
            updateUser({name: 'email', value: normalizedState.user.email})
        }
    
        if (normalizedState.user && normalizedState.user.id) {
            updateUser({name: 'id', value: normalizedState.user.id})
        }
    }

    validate() {
        return validate().then(
            response => {
                let userErrors;

                if (response && response.user) {
                    userErrors = response.user;
                }

                if (!userErrors) {
                    return Promise.resolve();
                }

                this.mergeUserErrors(userErrors);
                return Promise.reject(userErrors);
            }
        );
    }

    submit() {
        return submit().then(
            response => {
                if (response.redirect_url && response.uid && response.oid) {
                    return Promise.resolve(response)
                }

                const userErrors = response.user || '';
                if (userErrors) {
                    this.mergeUserErrors(userErrors);
                }

                return Promise.reject(response);
            },
            error => console.log(error)
        );
    }

    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    /**
     * @param {function} callback
     */
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    dispatchToken = Dispatcher.register((action) => {
        const { payload } = action;

        switch (action.type) {
            case Actions.UPDATE_USER:
                for (let name in payload) {
                    let value = payload[name];
                    updateUser({ name, value });
                }
                break;
            case Actions.UPDATE_SHOWTIPS:
                for (let name in payload) {
                    let value = payload[name];
                    updateShowTips({ name, value });
                }
                break;
            case Actions.SET_VALID_TOKEN:
                setValidToken(payload.token);
                break;
            case Actions.SET_AUTOLOGIN_HASH:
                setAutologinHash(payload.hash);
                break;
            case Actions.SEND_USER_TO_GA:
                sendToGa();
                break;
            case Actions.SET_VV_AUTHORIZATION_STATUS:
                setVVauthorizationStatus(payload.authorized);
                break;
            case Actions.SET_USER_BALANCE:
                setUserBalance(payload.balance);
                break;
            default:
                return;
        }

        this.emitChange();
    })

}

export default new UserStore();



// WEBPACK FOOTER //
// ./client/stores/UserStore.js